import { render, staticRenderFns } from "./AdaptiveImage.vue?vue&type=template&id=fa71a5ee&scoped=true"
import script from "./AdaptiveImage.vue?vue&type=script&lang=js"
export * from "./AdaptiveImage.vue?vue&type=script&lang=js"
import style0 from "./AdaptiveImage.vue?vue&type=style&index=0&id=fa71a5ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa71a5ee",
  null
  
)

export default component.exports